import React from 'react';

const NoTours = () => (
  <div className="noTours">
    <div id="house" />
    <span className="headline">Schedule tours on&nbsp;‘Explore’</span>
    <span className="explainerText">
      Your scheduled tours
      <br />
      will show up here!
    </span>
    <span className="arrow" />
  </div>
);

NoTours.displayName = 'NoTours';

export default NoTours;
